module.exports = new __parcel__URL__("troops_super_swole_small.c1593761.png").toString();